export const ROUTES = {
  root: '/',
  dicts: '/dicts/',
  directory: ':directory',
  all: 'all',
  matching: 'matching',
};
